import { common } from "./en/common";
import { auth } from "./en/auth";
import { onboarding } from "./en/onboarding";
import { profile } from "./en/profile";
import { settings } from "./en/settings";
import { matching } from "./en/matching";
import { chat } from "./en/chat";
import { company } from "./en/company";
import { events } from "./en/events";
import { checkin } from "./en/checkin";
import { miniApps } from "./en/mini-apps";
import { card } from "./en/card";
import { connect } from "./en/connect";
import { points } from "./en/points";
import { demo } from "./en/demo";
import { native } from "./en/native";
import { landing } from "./en/landing";
import { tags } from "./en/tags";
import { postMeetup } from "./en/post-meetup";

export const en = {
  ...common,
  ...auth,
  ...onboarding,
  ...profile,
  ...settings,
  ...matching,
  ...chat,
  ...company,
  ...events,
  ...checkin,
  ...miniApps,
  ...card,
  ...connect,
  ...points,
  ...demo,
  ...native,
  ...landing,
  ...tags,
  ...postMeetup,
};
